import React from 'react';

import './Skeleton.scss';

function Skeleton() {
	return <div className="ast-skeleton ast-skeleton--wave"></div>;
}

export default Skeleton;
